import {i18n} from '@/plugins/i18n'

export const ibanDetectStatus = {
    ACTIVE: 1,
    INACTIVE: 2,
};

export const ibanDetectStatusStr = {
    ACTIVE: i18n.t('label.active'),
    INACTIVE: i18n.t('label.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(ibanDetectStatus).forEach(item => {
            if (ibanDetectStatus[item] === status) {
                status_str = ibanDetectStatusStr[item];
            }
        });

        return status_str;
    }
};
